/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_End_SavedInputs */

const en_us2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you logged is saved.`)
};

const pt_br2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você registrou fica salvo.`)
};

const es_419_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que registraste queda guardado.`)
};

const pt_pt2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que registaste fica guardado.`)
};

const fr_fr2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que tu as enregistré est conservé.`)
};

const de_de2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was du erfasst hast, ist gespeichert.`)
};

const it_it2_workout_after_end_saved = /** @type {(inputs: Workout_After_End_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quello che hai registrato resta salvato.`)
};

/**
* | output |
* | --- |
* | "What you logged is saved." |
*
* @param {Workout_After_End_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_saved = /** @type {((inputs?: Workout_After_End_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_saved(inputs)
	if (locale === "es-419") return es_419_workout_after_end_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_saved(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_saved(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_saved(inputs)
	return en_us2_workout_after_end_saved(inputs)
});
export { workout_after_end_saved as "workout-after.end_saved" }